import { inject, Signal, signal } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { environment } from 'src/environments/environment';

import { GqlService } from '@shared/services/gql.service';
import { MainQuery } from '@shared/store/main/main.query';
import { gqlToPromise } from '@shared/utils/gql-to-promise';

export const injectListBudgetAttributesQuery = ({
  budgetVersionId = signal(''),
  vendorId = signal(''),
}: {
  budgetVersionId?: Signal<string>;
  vendorId?: Signal<string>;
} = {}) => {
  const gqlService = inject(GqlService);
  const mainQuery = inject(MainQuery);

  return injectQuery(() => ({
    queryFn: () => {
      if (environment.usePlayground) {
        return import('./list-budget-attributes-query.mock').then(
          (m) => m.listBudgetAttributesMock.data
        );
      }

      return gqlToPromise(() => {
        return gqlService.listBudgetAttributes$(budgetVersionId(), vendorId());
      });
    },
    queryKey: [
      'trials',
      'detail',
      mainQuery.trialKey(),
      'list-budget-attributes',
      {
        budgetVersionId: budgetVersionId(),
        vendorId: vendorId(),
      },
    ],
  }));
};
